// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__37qwh","header":"ReportDetails_header__1QRvJ","title":"ReportDetails_title__r6gj-","left":"ReportDetails_left__2saAy"};